import { InjectionToken } from '@angular/core';

export interface SdkConfig {
  showTranslationKeys?: boolean;
}

export const SDK_CONFIG = new InjectionToken<SdkConfig>('[SDK] Config');
